/**
 * 品質判定の不合格理由（banner_quality_evaluations.failed_checks）の表示名。
 * 文字・余計な物・CTA は Clef が画像を見て、業種・スタイルは Jev が商品とスタイルの説明から判定する。
 */
export const CLEF_CHECK_LABELS: Record<string, { label: string; description: string }> = {
  garbled_text: { label: '文字崩れ', description: 'Clef（画像）: 文字が崩れている' },
  unrelated_object: { label: '無関係な物', description: 'Clef（画像）: 商品と関係ない物・人・動物が写っている' },
  missing_cta: { label: 'CTAなし', description: 'Clef（画像）: 指示で CTA を求めたのに、画像に CTA がない' },
  category_mismatch: { label: '業種違い', description: 'Jev（文章）: 商品の業種と違うスタイルが選ばれている' },
  style_mismatch: { label: 'スタイル違い', description: 'Jev（文章）: 商品に合わないスタイルが選ばれている' },
};

export const clefCheckLabel = (check: string): string => CLEF_CHECK_LABELS[check]?.label ?? check;
export const clefCheckDescription = (check: string): string => CLEF_CHECK_LABELS[check]?.description ?? check;
